import React from "react";
import "styles/components/_side-menu.scss";

const SideMenu = () => {
    return <div className="c-side-menu"></div>;
};

export default SideMenu;
